export const ECOMM_SITES = ['en-US', 'en-CA', 'fr-CA'];
